export default __webpack_public_path__ + "images/predict_on_upload-k6nKd.png";